// extracted by mini-css-extract-plugin
export default {"summary":"SuperOrderSummary_summary__Qa-fw","block":"SuperOrderSummary_block__T7gBV","address":"SuperOrderSummary_address__Fa0+L","blockTitle":"SuperOrderSummary_blockTitle__yulFb"};